import { ProblemOptionsModel } from '@generativ/much-smarter-models';


export class ProblemInfo {
  problem: ProblemOptionsModel;
  solutionId: number;
  isLastProblem: boolean;
}
